import { Injectable } from '@angular/core';
import { copyList, deleteList } from '@firebird-web/custom-locations-store';
import { DialogService } from '@firebird-web/shared-ui';
import { Store } from '@ngrx/store';
import { FavoriteList } from '../../../../custom-locations-store/src/lib/models/favorite-locations.types';
import { CreateListComponent } from '../components/create-list/create-list.component';
import { SETTINGS_DIALOG_CONFIG } from '../constants';

// Single entry point for the custom list editor, shared by Settings and the location picker.
@Injectable({ providedIn: 'root' })
export class CustomListEditorService {
  constructor(
    private readonly dialogService: DialogService,
    private readonly store: Store
  ) {}

  public open(list: Partial<FavoriteList>) {
    return this.dialogService.openDialog({
      component: CreateListComponent,
      config: SETTINGS_DIALOG_CONFIG,
      context: {
        list,
        deleteList: (listToDelete: FavoriteList) => {
          if (listToDelete.id) {
            this.store.dispatch(deleteList({ list: listToDelete }));
          }
        },
        copyList: (listToCopy: Partial<FavoriteList>) => {
          if (listToCopy.id) {
            this.store.dispatch(copyList({ list: listToCopy }));
          }
        },
      },
    });
  }
}
